import ScanDetailDialog from "./scanDetailDialog.container";

export default ScanDetailDialog;
